import React, {useEffect} from "react";
import Flicking from "@egjs/react-flicking";
import gsap from "gsap";

import elementInside from '../experience/dataExperience'
import Arrow from "./arrow/arrow"


const Slider = props =>{

    const lang = document.documentElement.lang === "it"
    let txtMove = lang ? "MUOVITI ATTRAVERSO LO SPETTRO" : "MOVE THROUGH THE SPECTRUM";
    let txtClick = lang ? "FAI TAP E SCOPRI DI PIÙ" : "TAP TO DISCOVER";

    useEffect(() =>{
        //gsap.to(".slider__cta", 2, {autoAlpha: 0, repeat: 3, yoyo: true, ease: Linear.easeNone });
        document.getElementById(props.cN).addEventListener('mouseenter', () => {
            document.getElementById("cursorID").classList.add("drag");
        });
        document.getElementById(props.cN).addEventListener('mouseleave', () => {
            document.getElementById("cursorID").classList.remove("drag");
        });
    })

    const endScrollHandler = (e) => {
        gsap.to(".slider__cta", 2, { autoAlpha:0, ease: "back.out(1.7)"});
        gsap.to(".slider__ctaClick", 2, { autoAlpha:0, ease: "back.out(1.7)"});
    }

    return(
        <div className={props.cN} id={props.cN}>
            <Arrow color={elementInside[props.color].color} />
            <p className="slider__ctaClick d-block d-md-none text-center"><span className="slider__ctaClick__cerchio"></span>{txtClick}</p>
            <p className="slider__cta">{"<< "+txtMove+" >>"}</p>
            <Flicking
                className="slider__colorSelector"
                ref={props.isRef}
                horizontal={true}
                renderOnlyVisible={true}
                circular="true"
                align="center"
                defaultIndex={props.color}
                onHoldStart={endScrollHandler}
                onWillChange={(e) => props.setColor(e.index)}
            >
                {elementInside.map((element, id) => <div key={id} style={{backgroundColor: `${element.color}`}} className="slider__colorSelector__content" ></div>)}
            </Flicking>
        </div>
    );
}

export default Slider